import { useId } from 'react'
import SearchIcon from '@nv/images/design/search-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './SearchBar.module.scss'

export const SearchBar = ({ label, style, name, disabled, onChange, value, placeholder }: any) => {
  const inputId = useId()
  const { t } = useTranslation()

  return (
    <div className={clsx(styles['container'])} style={style?.container}>
      <label htmlFor={inputId} className={styles['label']}>
        {`${label}`}
      </label>
      <div className={clsx(styles['search'])}>
        <SearchIcon className={styles['img']} />
        <input
          id={inputId}
          className={styles['input']}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          onChange={onChange}
          value={value}
          autoComplete='off'
        />
      </div>
    </div>
  )
}
